document.addEventListener('DOMContentLoaded', () => {
  // obecne
  let bodyWidth = window.innerWidth;

  // události při resize okna
  window.addEventListener('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });
  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if (document.querySelector('.nav-switcher').classList.contains('is-open')) {
      document.querySelector('.nav-switcher').classList.remove('is-open');
      document.querySelector('.nav').classList.remove('is-open');
      document.body.classList.remove('is-unscrollable');
    } else {
      document.querySelector('.nav-switcher').classList.add('is-open');
      document.querySelector('.nav').classList.add('is-open');
      document.body.classList.add('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    document.querySelector('.nav-switcher').classList.remove('is-open');
    document.querySelector('.nav').classList.remove('is-open');
    document.body.classList.remove('is-unscrollable');
  }

  document.querySelectorAll('.nav a').forEach((element) => {
    element.addEventListener('click', function () {
      resetMenu();
    });
  });

  // spouštěč
  document.querySelector('.nav-switcher').addEventListener('click', function () {
    switchMenu();
  });

  // události při načtení stránky
  window.addEventListener('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();
  });

  // události při scroolování
  window.addEventListener('scroll', function () {
    //...
  });

  // modal okna
  if (document.querySelector('.modal')) {
    modal();
  }

  // slider
  if (document.querySelector('.slider')) {
    const slider = new Glider(document.querySelector('.slider'), {
      slidesToShow: 2,
      slidesToScroll: 1,
      draggable: true,
      scrollLock: true,
      scrollLockDelay: 0,
      rewind: true,
    });
    gliderAutoplay(slider, { interval: 6000 });
  }

  // faq
  if (document.querySelector('.faq')) {
    faqQuestion = document.getElementsByClassName('faq__question');
    for (i = 0; i < faqQuestion.length; i++) {
      faqQuestion[i].addEventListener('click', function () {
        if (this.closest('.faq__item').classList.contains('is-open')) {
          this.closest('.faq__item').classList.remove('is-open');
        } else {
          this.closest('.faq__item').classList.add('is-open');
        }
      });
    }
  }

  // gallery slider
  if (document.querySelector('.gallery-swiper')) {
    const swiper1 = new Swiper('.gallery-swiper', {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      coverflowEffect: {
        rotate: 10,
        stretch: -10,
        depth: 100,
        modifier: 1,
        slideShadows: false,
        scale: 0.85,
      },
      navigation: {
        nextEl: '.gallery-swiper-button-next',
        prevEl: '.gallery-swiper-button-prev',
      },
    });
    const swiper2 = new Swiper('.gallery-swiper-content', {
      slidesPerView: '1',
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.gallery-swiper-button-next',
        prevEl: '.gallery-swiper-button-prev',
      },
      fadeEffect: {
        crossFade: true,
      },
    });
    // Propojení obou sliderů
    // swiper1.controller.control = swiper2;
    // swiper2.controller.control = swiper1;
  }

  // references slider
  if (document.querySelector('.references-swiper')) {
    const swiper3 = new Swiper('.references-swiper', {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.references-swiper-button-next',
        prevEl: '.references-swiper-button-prev',
      },
      fadeEffect: {
        crossFade: true,
      },
    });
  }

  // blog article list - show more button
  const showMoreArticleLink = document.getElementById('js-blog-show-more');
  const blogArticles = document.getElementsByClassName('blog-item');
  if (showMoreArticleLink) {
    showMoreArticleLink.addEventListener('click', function () {
      blogArticles.forEach(function (blogArticle) {
        blogArticle.classList.remove('is-hidden');
      });
      showMoreArticleLink.classList.add('is-hidden');
    });
  }

  if (document.querySelector('.js-fire')) {
    const overlays = document.querySelectorAll('.fire.js-fire');
    const randomOffset = (base, range) => base + (Math.random() * range - range / 2);
    // Animace jednoho overlay
    const animateOverlay = (overlay) => {
      let xOffset = -50; // Počáteční hodnota pro translateX
      let yOffset = -50; // Počáteční hodnota pro translateY
      let xDirection = Math.random() > 0.5 ? 1 : -1; // Náhodný směr pro X
      let yDirection = Math.random() > 0.5 ? 1 : -1; // Náhodný směr pro Y

      const animate = () => {
        // Vytvoření náhodných změn v rozsahu ±20 %
        xOffset += xDirection * randomOffset(0, 1);
        yOffset += yDirection * randomOffset(0, 1);

        // Omezení na krajní hodnoty (-70 %, -30 %)
        if (xOffset > -30 || xOffset < -70) xDirection *= -1;
        if (yOffset > -30 || yOffset < -70) yDirection *= -1;
        // Aktualizace transformace
        overlay.style.transform = `translate(${xOffset}%, ${yOffset}%)`;
        // Opětovné spuštění animace
        requestAnimationFrame(animate);
      };
      animate();
    };
    // Spuštění animace pro všechny overlay vrstvy
    overlays.forEach((overlay) => {
      animateOverlay(overlay);
    });
  }
  // galerie
  if (document.querySelector('.js-gallery')) {
    new SimpleLightbox('.js-gallery a', {
      showCounter: false,
      captionClass: 'center',
    });
  }
  if (document.querySelector('.js-gallery-coverflow')) {
    new SimpleLightbox('.js-gallery-coverflow a', {
      showCounter: false,
      captionClass: 'center',
    });
  }
  if (document.querySelector('.js-gallery-references')) {
    new SimpleLightbox('.js-gallery-references a', {
      showCounter: false,
      captionClass: 'center',
    });
  }
});
